import { Dropdown, Link, Text } from 'components';
import React from 'react';
import styled from 'styled-components';
import { AppointmentStatus } from '@bb/domain/dist/types';
import { ListingCalendarMenu } from '../types';
import { useShowingsCalendarContext } from '../ShowingsCalendarContext';

type ShowingCountsType = {
  label: string;
  key: AppointmentStatus | 'total' | 'pending';
}[];

const ShowingsDropdown: React.FC = () => {
  const inPersonShowingCounts: ShowingCountsType = [
    { label: 'Total', key: 'total' },
    { label: 'New', key: 'new' },
    { label: 'Attempted', key: 'attempted' },
    { label: 'Confirmed', key: 'confirm' },
    { label: 'Denied', key: 'deny' },
    { label: 'Cancelled', key: 'cancel' },
    { label: 'Time Changed', key: 'time_change' },
    { label: 'Time Passed', key: 'time_passed' },
    { label: 'Awaiting Approval', key: 'pending' },
  ];
  const VirtualShowingCounts: ShowingCountsType = [
    { label: 'Total', key: 'total' },
    { label: 'Confirmed', key: 'confirm' },
    { label: 'Cancelled', key: 'cancel' },
    { label: 'Time Passed', key: 'time_passed' },
  ];

  const { selectedMenuOption, totalShowingsCount, statusCount } =
    useShowingsCalendarContext();

  const counts =
    selectedMenuOption === ListingCalendarMenu.InPerson
      ? inPersonShowingCounts
      : VirtualShowingCounts;

  const getStatusCount = (key: AppointmentStatus | 'total' | 'pending') => {
    if (key === 'total') {
      return totalShowingsCount;
    }
    // todo: uncomment out when remove status is replaced by time_passed status
    // if (key === 'time_passed') {
    //   return (statusCount[key] || 0) + (statusCount['removed'] || 0);
    // }
    const count = statusCount[key];
    return count || 0;
  };

  return (
    <Dropdown
      trigger={['click']}
      placement="bottomRight"
      dropdownRender={() => (
        <StyledShowingsCountsContainer>
          <StyledListContainer>
            {counts.map(({ key, label }) => (
              <StyledCountsTextContainer key={key}>
                <Text
                  textAlign="right"
                  strong
                  data-cy={`${label}-showings-count`}
                >
                  {getStatusCount(key)}
                </Text>
              </StyledCountsTextContainer>
            ))}
          </StyledListContainer>
          <StyledListContainer>
            {counts.map(({ label }) => (
              <StyledCountsTextContainer key={label}>
                <Text>{label}</Text>
              </StyledCountsTextContainer>
            ))}
          </StyledListContainer>
        </StyledShowingsCountsContainer>
      )}
    >
      <StyledLink underlineOnHover>{totalShowingsCount} Showings</StyledLink>
    </Dropdown>
  );
};

const StyledShowingsCountsContainer = styled.div`
  background-color: white;
  padding: 5px 20px;
  width: 100%;
  border-radius: 8px;
  display: flex;
  box-shadow: 0px 4px 12px 0px rgb(0 0 0 / 15%);
`;

const StyledListContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 5px;
`;

const StyledCountsTextContainer = styled.div`
  margin: 5px 0 5px 0;
`;

const StyledLink = styled(Link)`
  margin-right: 10px;
`;

export default ShowingsDropdown;
